import {SearchInputAreaSIBox} from "./search-input-area.si.box";

export const SearchInputAreaSICisBox = SearchInputAreaSIBox;
